import { call, put } from 'redux-saga/effects';
import ApplyLeaveActions from '../redux/ApplyLeaveRedux';
import { api } from './api';


export function* applyleavesagas(action: any): Generator<any, void, any> {
  const { leave_id } = action;
  const response = yield call(api.applyLeave, leave_id);

  // success?
  if (response.ok) {
    // You might need to change the response here - do this with a 'transform',
    // located in ../Transforms/. Otherwise, just pass the data back from the api.
    yield put(ApplyLeaveActions.applyLeaveSuccess(response.data));
  } else {
    yield put(ApplyLeaveActions.applyLeaveFailure(response.data));
  }
}